import {h, Fragment} from "preact"
import { useFacets, useAppStateSelector, pick } from "@nosto/preact"
import FacetItemWrapper from "./FacetItemWrapper"
import RangeFacet from "./RangeFacet"
import SelectedFilters from "./SelectedFilters"
import { useEffect, useRef } from "preact/hooks"
import {MobileSortBlock, Icon} from "./elements"
import { settings } from "../config"

export const toggleButtonId = "toggle-mobile-sidebar"

function ToggleSidebarButton({ className }) {
    return (
        <label
            className={`ns-act-btn ns-close-sidebar ns-absolute ns-clickable ${className}`} 
            for={toggleButtonId}>
            <Icon name="close" />
        </label>
    )
}

export default function SideBar() {
    const { facets } = useFacets()
    const inputRef = useRef(null)

    const { query, response, pageType } = useAppStateSelector(state =>
        pick(state, "loading", "query", "response", "pageType")
    )

    const docCount = response.products?.total ?? 0;

    const totalSummary = pageType === "category" ? `${docCount} results` : `'${query.query}' - ${docCount} results`

    useEffect(() => {
        const listener = () => {
            if (window.innerWidth <= 1024 && inputRef.current?.checked) {
                return;
            }

            if (window.innerWidth > 1024 && inputRef.current) {
                inputRef.current.checked = true;
            } else if (window.innerWidth <= 1024 && inputRef.current) {
                inputRef.current.checked = false;
            }
        }

        window.addEventListener('resize', listener)
        listener();

        return () => {
            window.removeEventListener('resize', listener)
        }
    }, [])

    const siblingCollections = settings.sibling_collections && Array.isArray(settings.sibling_collections) ? settings.sibling_collections : [];
    const currentUrl = window.location.pathname;

    return facets?.length > 0 ? (
        <>
            <input ref={inputRef} type="checkbox" id={toggleButtonId} class="ns-facet-sidebar-toggle ns-d-none" />
            <label
                class="ns-sidebar-backdrop ns-fixed ns-w-100 ns-h-100 ns-background-black ns-d-none"
                for={toggleButtonId}
            />
            <div class="ns-sidebar-wrapper ns-d-none ns-d-l-block ns-h-100 ns-col-3">
                <div class="ns-sidebar-content ns-relative ns-h-100 ns-mr-0 ns-mr-l-auto">
                     <div class="mobile-facets__header page-width ns-only-mobile">
                        <div class="mobile-facets__header-inner">
                            <span class="mobile-facets__heading font-primary heading-1-md large-up-hide">{"Filter & Sort"}</span>
                            <ToggleSidebarButton />
                        </div>
                     </div>
                    <div class="ns-sidebar-menu">
                        {siblingCollections.length ? (
                            <div role="tabList" class="gender-filter ns-only-desktop">
                                {siblingCollections.map(item => (
                                    <a 
                                        class="tab-button font-primary nav" 
                                        href={item.url} 
                                        aria-selected={currentUrl === item.url ? 'true' : 'false'}>
                                            {item.name}
                                    </a>
                                ))}
                            </div>
                        ) : null}
                        <SelectedFilters />
                        <ul class="ns-list-unstyled ns-p-0 ns-m-0">
                            <MobileSortBlock />
                            {facets?.map(facet => {
                                switch (facet.type) {
                                    case "terms":
                                        return <FacetItemWrapper key={facet.id} facet={facet} />
                                    case "stats":
                                        return <RangeFacet key={facet.id} facet={facet} />
                                    default:
                                        return null
                                }
                            })}
                        </ul>
                    </div>
                    <div class="mobile-facets__footer ns-only-mobile">
                        <p class="mobile-facets__count font-secondary mono-sm">
                            {totalSummary}
                        </p>
                        <label for={toggleButtonId} class="button button--primary">Apply</label>
                    </div>
                </div>
            </div>
        </>
    ) : (
        ""
    )
}
